/**
 * <s-header-autohide> — slides the storefront <header> away on scroll down and back in on scroll up.
 *
 * Writes `data-autohide-hidden` on the header; the landing page's mobile CSS (config/styles.css) slides
 * the header up out of view while that attribute is present. Without that CSS the attribute is harmless. The header stays put while focus is inside it (open menu, search, etc.).
 */
class SHeaderAutohide extends HTMLElement {
  #ac;
  #header;
  #lastY = 0;
  #ticking = false;

  connectedCallback() {
    this.#header = document.querySelector('body > header');
    if (!this.#header) return;
    this.#ac = new AbortController();
    this.#lastY = window.scrollY;
    window.addEventListener('scroll', () => this.#queue(), { passive: true, signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #queue() {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(() => {
      this.#ticking = false;
      this.#update();
    });
  }

  #update() {
    const y = Math.max(window.scrollY, 0);
    const delta = y - this.#lastY;
    if (Math.abs(delta) < 6) return;
    this.#lastY = y;
    if (y > 10 && delta > 0) {
      if (!this.#header.matches(':focus-within')) this.#header.setAttribute('data-autohide-hidden', '');
    } else {
      this.#header.removeAttribute('data-autohide-hidden');
    }
  }
}

customElements.define('s-header-autohide', SHeaderAutohide);
